module.exports = __webpack_public_path__ + "img/title-bg.ec9c38d5.png";